import { PuzzleTypeFilterState, PuzzlePackTypeFilterState } from 'client/reducers/puzzleFilterReducer'
import { Dispatch } from 'redux'
import { PuzzleFilterAction } from './types'

export const SET_PUZZLE_FILTER = 'SET_PUZZLE_FILTER'
export const PRESET_PUZZLE_FILTERS = 'PRESET_PUZZLE_FILTERS'
export const SET_PUZZLE_PACK_TYPE_FILTER = 'SET_PUZZLE_PACK_TYPE_FILTER'
export const PRESET_PUZZLE_PACK_TYPE_FILTERS = 'PRESET_PUZZLE_PACK_TYPE_FILTERS'

export const setPuzzleFilter = (filter: PuzzleTypeFilterState) => (dispatch: Dispatch<PuzzleFilterAction>) => {
  dispatch({
    type: SET_PUZZLE_FILTER,
    payload: filter,
  })
}

export const presetPuzzleFilters = (filter: PuzzleTypeFilterState) => (dispatch: Dispatch<PuzzleFilterAction>) => {
  dispatch({
    type: PRESET_PUZZLE_FILTERS,
    payload: filter,
  })
}

export const setPuzzlePackTypeFilter = (filter: PuzzlePackTypeFilterState) => (dispatch: Dispatch<PuzzleFilterAction>) => {
  dispatch({
    type: SET_PUZZLE_PACK_TYPE_FILTER,
    payload: filter,
  })
}

export const presetPuzzlePackTypeFilters = (filter: PuzzlePackTypeFilterState) => (dispatch: Dispatch<PuzzleFilterAction>) => {
  dispatch({
    type: PRESET_PUZZLE_PACK_TYPE_FILTERS,
    payload: filter,
  })
}
